import type { BringBuyersStats, PilotSeller } from "../../common/requests/bringBuyers/endpoints";
import { formatMoney } from "../../common/utils/format";

/** "3", or "3 · 2 signed up, not paid yet" */
export function buyersText(stats: BringBuyersStats): string {
  return stats.signups ? `${stats.buyers} · ${stats.signups} signed up, not paid yet` : String(stats.buyers);
}

/** "S$5.00 · 1 voucher", or "None yet" */
export function vouchersText(stats: BringBuyersStats): string {
  if (!stats.vouchers) return "None yet";
  return `${formatMoney(stats.vouchers_paid, stats.currency || "SGD")} · ${stats.vouchers} voucher${stats.vouchers === 1 ? "" : "s"}`;
}

/** Pilot sellers matching a search on name, email, code or id. */
export function filterPilot(rows: PilotSeller[], query: string): PilotSeller[] {
  const q = query.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter((s) => `${s.username ?? ""} ${s.email ?? ""} ${s.code ?? ""} ${s.seller_id}`.toLowerCase().includes(q));
}
